import React from "react";
import { ReactController } from "../react_controller";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { EventRequestFieldGrid } from "../../components/grids/EventRequestFieldGrid";

const queryClient = new QueryClient();

export class EventRequestFieldGridController extends ReactController {
  connect() {
    this.root.render(
      <QueryClientProvider client={queryClient}>
        <EventRequestFieldGrid {...this.propsValue} />
      </QueryClientProvider>
    );
  }
}
